import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ScrollToTop from "../components/ScrollToTop";
import SchemaOrg from "../seo/SchemaOrg";

/**
 * MainLayout — wraps all public pages.
 * Provides the Navbar + Footer shell and a Suspense fallback for lazy-loaded pages.
 */
const MainLayout = () => {
  return (
    <div className="tw-flex tw-flex-col tw-min-h-screen">
      <SchemaOrg />
      <ScrollToTop />
      <Navbar />
      <main className="tw-flex-1">
        <Suspense
          fallback={
            <div className="tw-flex tw-items-center tw-justify-center tw-min-h-screen tw-bg-light">
              <div className="tw-flex tw-flex-col tw-items-center tw-gap-4">
                {/* Spinner */}
                <div className="tw-relative tw-w-14 tw-h-14">
                  <div className="tw-absolute tw-inset-0 tw-rounded-full tw-border-4 tw-border-teal/20" />
                  <div className="tw-absolute tw-inset-0 tw-rounded-full tw-border-4 tw-border-transparent tw-border-t-teal tw-animate-spin" />
                </div>
                <p className="tw-text-navy/50 tw-text-sm tw-font-medium tw-font-display tw-tracking-wide">
                  Loading...
                </p>
              </div>
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
